export default "__VITE_ASSET__DKucqFAO__"